import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { documentApi } from '../api/apiClient';
import { SearchIcon } from '../components/AppIcons';
import './WorkspaceSearchPage.css';

export default function WorkspaceSearchPage() {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [hits, setHits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!q.trim()) {
      setHits([]);
      return;
    }
    const t = setTimeout(async () => {
      setLoading(true);
      setError('');
      try {
        const res = await documentApi.search(workspaceId, q.trim(), 30);
        setHits(res.data || []);
      } catch (err) {
        setHits([]);
        setError('Search failed.');
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [q, workspaceId]);

  return (
    <div className="v-page v-search-page">
      <div className="v-breadcrumb">
        <button type="button" onClick={() => navigate('/workspaces')}>Workspaces</button>
        <span>/</span>
        <button type="button" onClick={() => navigate(`/workspaces/${workspaceId}`)}>Dashboard</button>
        <span>/</span>
        <span>Search</span>
      </div>

      <div className="v-page__header">
        <div>
          <h1 className="v-page__title">Search documents</h1>
          <p className="v-page__subtitle">Find text in file names and indexed chunks (no AI).</p>
        </div>
      </div>

      <div className="v-search-bar">
        <span className="v-search-bar__icon"><SearchIcon /></span>
        <input
          type="search"
          className="v-search-bar__input"
          placeholder="Search by keyword…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          autoFocus
        />
      </div>

      {error && <div className="v-search-error">{error}</div>}
      {loading && <div className="v-loading">Searching…</div>}

      {!loading && q.trim() && hits.length === 0 && (
        <div className="v-empty">No matches. Try another term or upload more documents.</div>
      )}

      <ul className="v-search-hits">
        {hits.map((h) => (
          <li key={`${h.documentId}-${h.chunkId || 'doc'}`} className="v-search-hit">
            <div className="v-search-hit__title">{h.documentName}</div>
            {h.chunkId != null && (
              <div className="v-search-hit__meta">Chunk {h.chunkIndex + 1} · score {h.score?.toFixed?.(2) ?? h.score}</div>
            )}
            <p className="v-search-hit__snippet">{h.snippet}</p>
            <button
              type="button"
              className="v-btn v-btn--ghost v-btn--sm"
              onClick={() => navigate(`/workspaces/${workspaceId}/documents`)}
            >
              Open document library
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
